var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a618907d6ba1278020589729efb08e5.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42eb4f8b586724e42a7b53de0beab554.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    